import { Component, Input, Output, EventEmitter } from "@angular/core";
import { TPR_BROKER_DETAIL_COLUMN_PICKER_ITEMS } from "src/app/tpr/tpr-constants";

@Component({
  selector: "app-column-picker-modal",
  templateUrl: "./column-picker-modal.component.html",
  styleUrls: ["./column-picker-modal.component.scss"],
})
export class ColumnPickerModalComponent {
  @Input() isModalVisible = false;
  @Input() data = TPR_BROKER_DETAIL_COLUMN_PICKER_ITEMS;
  @Output() onApply = new EventEmitter();
  @Output() onCancel = new EventEmitter();
  @Output() onReset = new EventEmitter();
  @Output() onDrag = new EventEmitter();

  hanldeCancelClick() {
    this.onCancel.emit();
  }

  handleColumnDrag(data) {
    this.onDrag.emit(data);
  }

  hanldeResetClick() {
    this.onReset.emit();
  }

  hanldeApplyClick(value) {
    this.onApply.emit(value);
  }

  hasDragColumnObserver() {
    return this.onDrag.observers.length !== 0;
  }
}
